// Orari di tappa: dim_race_stage.stage_date + stage_time sono l'ora di Roma, senza fuso.
// new Date('2027-01-19T12:00:00') li leggerebbe nel fuso del telefono: fuori dall'Italia il conto alla rovescia sbaglierebbe.
// Qui diventano l'istante vero (regola UE: ora legale dall'ultima domenica di marzo all'ultima di ottobre, alle 01:00 UTC).
const ultimaDomenica = (anno, mese) => {
  const ultimo = new Date(Date.UTC(anno, mese + 1, 0))
  return ultimo.getUTCDate() - ultimo.getUTCDay()
}

export function romeInstant(dateStr, timeStr) {
  const [y, mo, d] = String(dateStr).split('T')[0].split('-').map(Number)
  const [h, mi, s] = String(timeStr).split(':').map(Number)
  const locale = Date.UTC(y, mo - 1, d, h, mi, s || 0)
  const inizioLegale = Date.UTC(y, 2, ultimaDomenica(y, 2), 1)
  const fineLegale = Date.UTC(y, 9, ultimaDomenica(y, 9), 1)
  const comeEstate = locale - 2 * 3600000
  const offsetOre = comeEstate >= inizioLegale && comeEstate < fineLegale ? 2 : 1
  return new Date(locale - offsetOre * 3600000)
}

// Data di oggi a Roma (AAAA-MM-GG): serve dove si confronta con stage_date / race_date.
// new Date().toISOString() darebbe la data UTC, che tra mezzanotte e le 01-02 e' ancora quella di ieri.
export function romeToday() {
  const ora = new Date()
  const y = ora.getUTCFullYear()
  const inizioLegale = Date.UTC(y, 2, ultimaDomenica(y, 2), 1)
  const fineLegale = Date.UTC(y, 9, ultimaDomenica(y, 9), 1)
  const offsetOre = ora.getTime() >= inizioLegale && ora.getTime() < fineLegale ? 2 : 1
  return new Date(ora.getTime() + offsetOre * 3600000).toISOString().slice(0, 10)
}

// Ora di adesso a Roma (HH:MM), per confrontarla con stage_time.
export function romeHHMM() {
  const ora = new Date()
  const y = ora.getUTCFullYear()
  const inizioLegale = Date.UTC(y, 2, ultimaDomenica(y, 2), 1)
  const fineLegale = Date.UTC(y, 9, ultimaDomenica(y, 9), 1)
  const offsetOre = ora.getTime() >= inizioLegale && ora.getTime() < fineLegale ? 2 : 1
  return new Date(ora.getTime() + offsetOre * 3600000).toISOString().slice(11, 16)
}
